// MIT License

// Copyright (c) 2018 Greg Hovanesyan



const generateRandomIdString = prefix => Math.random().toString(36).replace('0.', prefix || '');

export default generateRandomIdString;
